"use strict";

require("jquery-ui/ui/slider");
require("./../libs/jqueryNativeTrigger");
require("jqueryui-touch-punch/jquery.ui.touch-punch");

var moduleName = "jquery-ui-slider-range";

function init() {
	$(".jsFilterItemLineRange").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);

		var $wrap = $(this),
			$slider = $wrap.find(".jsFilterItemLineRangeLine"),
			$fromInput = $wrap.find(".jsFilterItemLineRangeInputFrom"),
			$toInput = $wrap.find(".jsFilterItemLineRangeInputTo"),
			min = parseFloat($wrap.find(".jsFilterItemLineRangeSettings").attr("min")) || 0,
			max = parseFloat($wrap.find(".jsFilterItemLineRangeSettings").attr("max")) || 100000,
			step = parseFloat($wrap.find(".jsFilterItemLineRangeSettings").attr("step")) || 1;

		$slider.slider({
			range: true,
			min : min,
			max : max,
			step : step,
			values : getInputValues(),
			slide: function( event, ui ) {
				$fromInput.val(ui.values[0]);
				$toInput.val(ui.values[1]); 
			}
		});

		$fromInput.add($toInput).on("input change propertychange", function () {
			$slider.slider("values", getInputValues());
		});



		$slider.on("slidechange", function () {
			$fromInput.nativeTrigger("rangechange");
			$toInput.nativeTrigger("rangechange");
		});

		function getInputValues() {
			return [
				parseFloat($fromInput.val()) || 0,
				parseFloat($toInput.val()) || 0
			];
		}
	});
}

module.exports = init;


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/sliderRangeInit.js
 **/